import React, { useEffect, useRef, useState } from "react";
import _ from "lodash";
import ButtonElement from "../../../../Components/UiComponents/ButtonElement";
import DataTable from "../../../../Components/UiComponents/DataTable";
import ToastElement from "../../../../Components/UiComponents/ToastElement";
import Loader from "../../../../Components/UiComponents/Loader";
import { getControlField } from "../../../../Services/tooltipService";
import { getAllRoles } from "../../../../Services/roleService";
import { Dialog } from "primereact/dialog";
import ExcelUploader from "./ExcelUploader";
import InputTextElementElement from "../../../../Components/UiComponents/InputTextElement";
import TextareaElement from "../../../../Components/UiComponents/TextareaElement";
import { saveRole, updateRole, removeRole } from "../../../../Services/roleService";
import CheckboxElement from "../../../../Components/UiComponents/CheckboxElement";
import { InputIcon } from "primereact/inputicon";
import { useNavigate } from "react-router-dom";
import PlaylistVideos from "../../../../Components/Videos/PlaylistVideos";

const JobTitles = (props) => {
    const [customerId, setCustomerId] = useState(null);
    const [loading, setLoading] = useState(false);
    const [uploadPopup, setUploadPopup] = useState(false);
    const [controlPanelPermossionTab, setControlPanelPermossionTab] = useState('');
    const [cntlPannelUserclasification, setCntlPannelUserclasification] = useState('');
    const [controlPannelJobTitlesHeaders, setControlPannelJobTitlesHeaders] = useState([]);
    const navigate = useNavigate()
    const [controlJobTables, setControlJobTables] = useState([]);
    const [controlPannelUserTableHeaders, setControlPannelUserTableHeaders] = useState([]);
    const [roles, setRoles] = useState([]);
    const customerData = localStorage.getItem("enduser");
    if(customerData === null){
        navigate("/login")
        localStorage.clear()
    }
    const customerDataInJSON = JSON.parse(customerData);
    var branchData = customerDataInJSON.branch
    const toastRef = useRef()
    const [fileName, setFileName] = useState(null);
    const [position, setPosition] = useState("center");
    const [visible, setVisible] = useState(false);
    const [formData, setFormData] = useState({
        role_name: "",
        role_desc: "",
    });
    const [errors, setErrors] = useState({});
    const [editErrors, setEditErrors] = useState({});
    const [dataToDelete, setDataToDelete] = useState([]);
    const [deleteProductDialog, setDeleteProductDialog] = useState(false);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [selectedRole, setSelectedRole] = useState(null);
    const [selectedRoles, setSelectedRoles] = useState([]);
    const [showVideo, setShowVideo] = useState(false);


    useEffect(() => {
        const customerData = localStorage.getItem("enduser");
        if (customerData) {
            const customerDataInJSON = JSON.parse(customerData);
            setCustomerId(customerDataInJSON.customer);
        }else{
            navigate("/login")
            localStorage.clear()
        }
    }, []);

    useEffect(() => {
        if (customerId) {
            getControlFieldData();
            allUser();
        }
    }, [customerId]);

    const handleSave = (data) => {
        setFileName(data)
    }

    const getControlFieldData = async () => {
        try {
            if (customerId === null) {
                return;
            }
            var clientModuleData = await getControlField(customerId)
            var controlPanelModules = _.find(clientModuleData?.data?.cust[0].modules, { module_name: "Control Panel", status: true });
            const cntlPannel_Permissions = controlPanelModules.tabs.find(
                (tab) => tab.tab_name === "Job Titles"
            ).display_name;
            setControlPanelPermossionTab(cntlPannel_Permissions)

            var cntlPannel_JobTitles = _.find(controlPanelModules.tabs, { tab_name: "Job Titles" }).tables;
            setControlJobTables(cntlPannel_JobTitles)
            var ControlPannelJobTitlesHeaders = _.find(cntlPannel_JobTitles, { table_name: "Job Titles" }).headers;
            setControlPannelJobTitlesHeaders(ControlPannelJobTitlesHeaders)
            var cntlPannelUserclasification = _.find(controlPanelModules.tabs, { tab_name: "Job Titles" }).display_name;
            setCntlPannelUserclasification(cntlPannelUserclasification)

            var ControlPannelUserTableHeaders = _.find(cntlPannel_JobTitles, { table_name: "Job Titles" }).display_name;
            setControlPannelUserTableHeaders(ControlPannelUserTableHeaders)
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    const allUser = async () => {
        try {
            if (customerId === null) {
                return;
            }
            const userResponse = await getAllRoles(customerId, false);
            setRoles(userResponse?.data?.roles)
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
    }

    const setData = () => {
        setUploadPopup(true);
    };

    const onCloseUploadPopup = () => {
        setUploadPopup(false);
    };

    const show = (position) => {
        setPosition(position);
        setVisible(true);
    };

    const handleInputChange = (field, value) => {
        setFormData({
            ...formData,
            [field]: value,
        });
    };

    const handleEditInputChange = (field, value) => {
        setSelectedRole({
            ...selectedRole,
            [field]: value,
        });

    };

    const handleEditDescInputChange = (field, value) => {
        setSelectedRole({
            ...selectedRole,
            [field]: value,
        });

    };

    const onCloseDialogOpen = () => {
        setIsDialogOpen(false);
        setEditErrors({});
    };

    const confirmDeleteProduct = () => {
        setDeleteProductDialog(true);
    };

    const onCloseVisiblePopup = () => {
        setVisible(false);
        setFormData({
            role_name: "",
            role_desc: "",
        });
        setErrors({});
    };



    const validateForm = () => {
        let isValid = true;
        const newErrors = {};

        if (!formData.role_name) {
            newErrors.role_name = 'Role Name is required';
            isValid = false;
        }

        setErrors(newErrors);
        return isValid;
    };

    const validateEditForm = () => {
        let isValid = true;
        const newErrors = {};
        if (!selectedRole.role_name) {
            newErrors.role_name = 'Role Name is required';
            isValid = false;
        }
        setEditErrors(newErrors);
        return isValid;
    };

    // Handle the form submit
    const handleSubmit = async (e) => {
        e.preventDefault();
        if (validateForm()) {
            try {
                setLoading(true)
                const response = await saveRole(customerId, formData);
                setVisible(false);
                setFormData({
                    role_name: "",
                    role_desc: "",
                });
                allUser();
                if (response && response.data.success) {
                    toastRef.current.showToast({
                        type: 'success',
                        message: response.data.message
                    })
                }
                else {
                    toastRef.current.showToast({
                        type: 'error',
                        message: response.data.message
                    })
                }
            } catch (error) {
                toastRef.current.showToast({
                    type: 'error',
                    message: "Failed to create field"
                });
            } finally {
                setLoading(false)
            }
        }
    };

    const handleEditSubmit = async () => {
        if (validateEditForm()) {
            try {
                if (customerId === null) {
                    return;
                }
                const updateResponse = await updateRole(customerId, selectedRole);
                if (updateResponse && updateResponse.data.success) {
                    toastRef.current.showToast({
                        type: 'success',
                        message: updateResponse.data.message
                    })
                }
                else {
                    toastRef.current.showToast({
                        type: 'error',
                        message: updateResponse.data.message
                    })
                }
                allUser();
            } catch (error) {
                toastRef.current.showToast({
                    type: 'error',
                    message: "Failed to create field"
                });
            } finally {
                setIsDialogOpen(false);
            }
        }
    };

    const renderFooter = (a) => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="Cancel" className="cancel-new-button" onClick={onCloseVisiblePopup} />
                    <ButtonElement type="submit" label="Save" className="save-button" onClick={handleSubmit} />
                </div>
            </div>
        );
    }

    const renderEditFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="Cancel" className="cancel-new-button" onClick={onCloseDialogOpen} />
                    <ButtonElement type="submit" label="Update" className="save-button" onClick={handleEditSubmit} />
                </div>
            </div>
        );
    }

    const deleteField = async () => {
        setDeleteProductDialog(false);
        try {
            if (customerId === null) {
                return;
            }
            setLoading(true);
            const response = await removeRole(customerId, dataToDelete);
            if (response && response.data.success) {
                toastRef.current.showToast({
                    type: 'success',
                    message: response.data.message
                })
            }
            else {
                toastRef.current.showToast({
                    type: 'error',
                    message: response.data.message
                })
            }
            allUser();
            setDataToDelete([])
            window.location.reload()
        } catch (error) {
            toastRef.current.showToast({
                type: 'error',
                message: 'An error occurred. Please try again or Contact Admin.'
            });
        }
        finally {
            setLoading(false);
        }
    };

    const hideDeleteProductDialog = () => {
        setDeleteProductDialog(false);
    };

    // Define the footer for the delete product dialog with action buttons
    const deleteProductDialogFooter = () => {
        return (
            <div className="cancel-footer">
                <div className='align-center justify-end pb-0'>
                    <ButtonElement label="No" className="cancel-new-button" onClick={hideDeleteProductDialog} />
                    <ButtonElement type="submit" label="Yes" className="save-button" onClick={deleteField} />
                </div>
            </div>
        );
    }

    const handleCheckboxChange = (index, sub) => {
        // Determine if the clicked role is already checked
        const isAlreadyChecked = roles[index].checked;
        // Update the roles array
        const updatedRoles = roles.map((role, i) => ({
            ...role,
            checked: i === index ? !isAlreadyChecked : false, // Toggle the checked state for the clicked role
        }));
        // Set the updated roles to the state
        setRoles(updatedRoles);
    
        // Determine the newly selected role
        const newlySelectedRole = updatedRoles[index];
    
        // Update selectedRoles based on whether the item is checked
        if (newlySelectedRole.checked) {
            // Add to selectedRoles if not already present
            setSelectedRoles(prev => {
                // Remove any previously selected role and add the new one
                const updatedSelectedRoles = prev.filter(role => role._id !== newlySelectedRole._id);
                return [...updatedSelectedRoles, newlySelectedRole];
            });
        } else {
            // Remove from selectedRoles if unchecked
            // setSelectedRoles(prev => prev.filter(role => role._id !== newlySelectedRole._id));
            setSelectedRoles([]);
        }
    
        // Optionally, update the state for data to delete if needed
        setDataToDelete(newlySelectedRole);
    };
    
    const openRoleEdit = (open, index, role) => {
        // setSelectedRole(role);
        setSelectedRole({
            _id: role._id,
            role_name: role.role_name,
            role_desc: role.role_desc,
            originalRole: role.role_name
        });
        setIsDialogOpen(open);
    };

    const handleButtonClick = () => {
        setShowVideo(true);
    };

    const closeVideo = () => {
        setShowVideo(false);
    };

    return (
        <div>
            <ToastElement ref={toastRef} />
            <Loader loading={loading} />
            <div className="form-group row align-items-center mb-0 mt-0">
                <div className="col pr-0 pl-0">
                    <div className="flex align-items-center justify-space-between">
                        <p className="label-text">
                            {controlPanelPermossionTab}
                        </p>
                        <ButtonElement
                            className="upload-button"
                            type="button"
                            icon="pi pi-video"
                            onClick={handleButtonClick}
                        />
                    </div>
                    <p className="group-table-text-section">
                        Please upload roles for your company to use
                    </p>
                </div>
            </div>
            <div className="group-table-buttons mt-0">
                <div className="delete-button">
                    {selectedRoles.length > 0 && (
                        <ButtonElement
                            className="delete-button-icon"
                            type="button"
                            icon="pi pi-trash"
                            onClick={confirmDeleteProduct}
                        />
                    )}
                </div>
                <div className="group-table-search">
                    {/* <ButtonElement
                        className="upload-button"
                        type="button"
                        icon="pi pi-upload"
                        onClick={() => setData()}
                    /> */}
                    <ButtonElement
                        className="clear-filter-button"
                        type="button"
                        icon="pi pi-plus"
                        label="New"
                        onClick={() => show("right")}
                    />
                </div>
            </div>
            <div className="data-submit">
                {
                    <div className="group-table-data">
                        <table className="group-datatable">
                            <thead className="group-table-header">
                                <tr>
                                    <th colSpan={4}>{_.find(controlJobTables, { table_name: "Job Titles" })?.display_name}</th>
                                </tr>
                                <tr>
                                    <th className="checkbox-header width-2"></th>
                                    <th className="w-30">{_.find(controlPannelJobTitlesHeaders, { header_name: "Role Name" })?.display_name}</th>
                                    <th className="w-30">{_.find(controlPannelJobTitlesHeaders, { header_name: "Role Description" })?.display_name}</th>
                                    <th>Action</th>

                                </tr>
                            </thead>
                            <tbody className="group-table-row stakeplan">
                                <React.Fragment>
                                    {
                                        roles?.map((sub, ind) => (
                                            <tr key={sub._id}>
                                                <td className="width-2">
                                                    <CheckboxElement
                                                        id={`sub-${ind}`}
                                                        name={`sub-${ind}`}
                                                        checked={sub.checked || false}
                                                        onChangeCheck={() => handleCheckboxChange(ind, sub)} // Single select logic
                                                        className="mr-2"
                                                    />
                                                </td>
                                                <td className='w-30'>
                                                    <label className="form-label text-left">{sub.role_name}</label>
                                                </td>
                                                <td className='w-30'>
                                                    <label className="form-label text-left">{sub.role_desc}</label>
                                                </td>
                                                <td>
                                                    <InputIcon
                                                        className="pi pi-pencil ml-10"
                                                        onClick={() => openRoleEdit(true, ind, sub)}
                                                    />
                                                </td>
                                            </tr>
                                        ))}
                                </React.Fragment>
                            </tbody>
                        </table>
                    </div>
                }
            </div>
            <Dialog
                visible={deleteProductDialog}
                breakpoints={{ "960px": "75vw", "641px": "90vw" }}
                header="Confirm Delete"
                modal
                footer={deleteProductDialogFooter}
                onHide={hideDeleteProductDialog}
                className="table-dialog width-32"
                draggable={false}
            >
                <div className="confirmation-content">
                    {dataToDelete && (
                        <span>
                            {dataToDelete.length > 1 ? (
                                <span className="table-description">
                                    Are you sure you want to delete{" "}
                                    {/* {dataToDelete.map((item, index) => (
                                        <b key={index}>
                                            {item.role_name}vv
                                            {index < dataToDelete.length - 1 ? ", " : ""}
                                        </b>
                                    ))} */}
                                    ?
                                </span>
                            ) : (
                                <span className="table-description">
                                    Are you sure you want to delete{" "}
                                    {/* <b>{dataToDelete?.role_name}</b> */}
                                    ?
                                </span>
                            )}
                        </span>
                    )}
                </div>
            </Dialog>
            <Dialog
                header={"Add"}
                visible={visible}
                position="right"
                className="width-50vw"
                onHide={onCloseVisiblePopup}
                footer={renderFooter()}
                draggable={false}
            >
                <div className="new-field">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                    {_.find(controlPannelJobTitlesHeaders, { header_name: "Role Name" })?.display_name}:
                                </label>
                            </div>
                            <div className="col pr-0">
                                <InputTextElementElement
                                    id="roleName"
                                    value={formData.role_name}
                                    onChange={(e) => handleInputChange("role_name", e.target.value)}
                                    required
                                    className="w-full"
                                />
                                {errors.role_name && (
                                    <small className="text-danger">
                                        {errors.role_name}
                                    </small>
                                )}
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                    {_.find(controlPannelJobTitlesHeaders, { header_name: "Role Description" })?.display_name}:
                                </label>
                            </div>
                            <div className="col pr-0">
                                <TextareaElement
                                    id="role_desc"
                                    value={formData.role_desc}
                                    onChange={(e) => handleInputChange("role_desc", e.target.value)}
                                    className="w-full"
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </Dialog>
            <Dialog
                header={"Edit"}
                visible={isDialogOpen}
                position="right"
                className="width-50vw"
                onHide={onCloseDialogOpen}
                footer={renderEditFooter()}
                draggable={false}
            >
                <div className="new-field">
                    <form onSubmit={handleSubmit}>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                    {_.find(controlPannelJobTitlesHeaders, { header_name: "Role Name" })?.display_name}:
                                </label>
                            </div>
                            <div className="col pr-0">
                                <InputTextElementElement
                                    id="role_name"
                                    value={selectedRole?.role_name}
                                    onChange={(e) => handleEditInputChange("role_name", e.target.value)}
                                    required
                                    className="w-full"
                                />
                                {editErrors.role_name && (
                                <small className="text-danger">
                                    {editErrors.role_name}
                                </small>
                                )}
                            </div>
                        </div>
                        <div className="form-group row align-items-center mb-0 mt-0">
                            <div className="col-md-4 pl-0">
                                <label className="form-label text-left">
                                    {_.find(controlPannelJobTitlesHeaders, { header_name: "Role Description" })?.display_name}:
                                </label>
                            </div>
                            <div className="col pr-0">
                                <TextareaElement
                                    id="role_desc"
                                    value={selectedRole?.role_desc}
                                    onChange={(e) => handleEditDescInputChange("role_desc", e.target.value)}
                                    className="w-full"
                                />
                            </div>
                        </div>
                    </form>
                </div>
            </Dialog>
            <Dialog
                header={"Upload File"}
                visible={uploadPopup}
                position="top"
                className="width-50vw"
                onHide={onCloseUploadPopup}
                draggable={false}
            >
                <ExcelUploader
                    onCloseUploadPopup={onCloseUploadPopup}
                    handleSave={handleSave}
                />
            </Dialog>
            <Dialog id="videoModal" visible={showVideo}
                breakpoints={{
                    '1200px': '80vw',    // Larger modal on bigger screens
                    '1024px': '85vw',    // Slightly smaller for medium screens
                    '769': '90vw',     // Responsive on tablets
                    '641px': '95vw',     // Almost full-width on mobile
                }}
                modal className="table-dialog width-32" draggable={false} width="800px" height="500px" onHide={closeVideo}
            >
                <div className="video-overlay">
                    <div className="video-container">
                        <PlaylistVideos playlistId={process.env.REACT_APP_CONTROL_PANEL_PLAYLIST_ID} apiKey={process.env.REACT_APP_GOOGLE_API_KEY} module="control_panel_job" />
                    </div>
                </div>
            </Dialog>
        </div>
    )
}

export default JobTitles;
